<nz-upload
  [nzBeforeUpload]="beforeUpload">
  <button nz-button>
    <i nz-icon nzType="upload"></i><span>Click to Upload</span>
  </button>
</nz-upload>
